module.exports = __webpack_public_path__ + "img/icons8-marker-active.0b4fe536.svg";